import { Routes } from '@angular/router';
import { AldenLoginComponent } from './lib/components/login/login.component';

export const routes: Routes = [
  {
    path: 'login',
    component: AldenLoginComponent,
    data: {
      title: 'APP.SIGN_IN'
    }
  }
];